var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!_vm.$route.meta.isPublic)?_c('Topbar'):_vm._e(),_c('PageHeadHandler'),_c('Toast'),(_vm.$session.exists() && !_vm.$route.meta.isPublic)?_c('Sidebar'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }